import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useListenSize from '../hooks/useListenSize';
import { segmentEvent } from '../helpers/sendEvent';
import useApi from '../hooks/useApi';
import CircleLoading from '../assets/img/loading-circle.svg';
import CongratulationImg from '../assets/img/congratulation.png';

// eslint-disable-next-line no-shadow
function CheckLease() {
  const store = useSelector(state => ({
    checkoutUid: state.loanInfo?.checkoutUid,
    payFrequency: state.loanInfo?.payFrequency,
    monthlyTotal: state.loanInfo?.checkout?.monthly_total,
    cartTotal: state.loanInfo?.checkout?.cart_total,
  }));

  const { request, syncLoading: loading, syncError: error } = useApi();
  useListenSize();
  useEffect(() => {
    const loadData = async () => {
      segmentEvent('page', 'Lease Completion', {
        monthly_payment: store.monthlyTotal,
        pay_frequency: store.payFrequency,
        cart: store.cartTotal,
      });
      await request.syncRequest(store.checkoutUid);
    };
    loadData();
  }, []);

  const isSuccess = !loading && !error;

  useEffect(() => {
    if (isSuccess) {
      segmentEvent('track', 'Complete my lease button');
    }
  }, []);

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        {!isSuccess && <img className="k-check-lease-img" src={CircleLoading} alt="Loading" />}
        {isSuccess && <img className="k-check-lease-img" src={CongratulationImg} alt="Congratulation" />}
        {!isSuccess && (
          <>
            <h1>Your lease is almost done</h1>
            <p>
              Please have your sales associate retry the <br /> authorization to complete your transaction.
            </p>
          </>
        )}
        {isSuccess && (
          <>
            <h1>Your lease is done</h1>
            <p>In the next 24 hours, you will receive a welcome email with access to your online account.</p>
          </>
        )}

        <div className="k-submit k-error-button">
          <button
            type="button"
            disabled={!isSuccess}
            onClick={() => {
              window.open('https://katapult.com/', '_blank', 'noopener,noreferrer');
              segmentEvent('track', 'Complete my lease button clicked');
            }}
          >
            Complete my lease
          </button>
        </div>
      </section>
    </div>
  );
}

export default CheckLease;
